import HTTP from "@/http-common";

export const state = {
  customerNo: "",
  customerName: "",
  companyName: "",
  financials: [],
  contactLogs: [],
  credits: [],
  payments: []
};

export const mutations = {
  setContactLogs(state, contactLogs) {
    state.contactLogs = contactLogs;
  },
  setPayments(state, payments) {
    state.payments = payments;
  },
  setCredits(state, credits) {
    state.credits = credits;
  }
};

export const actions = {
  clearFinancials({ commit }) {
    commit("setContactLogs", []);
    commit("setPayments", []);
    commit("setCredits", []);
  },
  fetchFinancials({ commit }, customer) {
    return new Promise((resolve, reject) => {
      HTTP.post("reminder/GetFinancials", customer)
        .then(data => {
          let res = data.data;

          commit("setContactLogs", res.contactLogs.contact.contaclLog);
          commit("setPayments", res.payments);
          commit("setCredits", res.credits);
          resolve(res);
        })
        .catch(err => {
          reject(err.message);
        });
    });
  },

  addContactLog({ dispatch }, log) {
    return new Promise((resolve, reject) => {
      HTTP.post("reminder/UpdateCustomerFinancial", log)
        .then(data => {
          resolve(data.data);
        })
        .catch(err => {
          reject(err.message);
        });
    });
  }
};

export const getters = {
  contactLogs: state => {
    return state.contactLogs;
  },
  payments: state => {
    return state.payments;
  },
  credits: state => {
    return state.credits;
  }
};
